import {FromMessageInterface} from '../http/from-message.interface';
import {UserResponse} from './user-response';
import {UserRolesEnum} from './user-roles.enum';
import {AccessTokenPayload} from '../authentication/jwt/access-token-payload';

export class User implements FromMessageInterface<UserResponse> {

  private _id: string = '';
  private _email: string = '';
  private _roles: Array<UserRolesEnum> = [];
  private _lastName: string = '';
  private _firstName: string = '';
  private _country: string = '';
  private _hospital: string = '';
  private _profession: null|string = '';

  public get id(): string {
    return this._id;
  }

  public get email(): string {
    return this._email;
  }

  public get roles(): Array<UserRolesEnum> {
    return this._roles;
  }

  public get lastName(): string {
    return this._lastName;
  }

  public get firstName(): string {
    return this._firstName;
  }

  public get country(): string {
    return this._country;
  }

  public get hospital(): string {
    return this._hospital;
  }

  public get profession(): null|string {
    return this._profession;
  }

  public fromPayload(payload: AccessTokenPayload): this {
    this._id = payload.id;
    this._email = payload.email;
    this._roles = payload.roles as Array<UserRolesEnum>;
    this._lastName = payload.lastName;
    this._firstName = payload.firstName;
    return this;
  }

  public fromMessage(message: UserResponse): this {
    this._id = message.id;
    this._email = message.email;
    this._roles = message.roles as Array<UserRolesEnum>;
    this._lastName = message.lastName;
    this._firstName = message.firstName;
    this._country = message.country;
    this._hospital = message.hospital;
    this._profession = message.profession;
    return this;
  }

  public isAdminOrSubcontractor(): boolean {
    return (this.roles.includes(UserRolesEnum.ADMIN) ?? false) ||
      (this.roles.includes(UserRolesEnum.SUBCONTRACTOR) ?? false);
  }

}
